// extracted by mini-css-extract-plugin
export var blackText = "style-module--blackText--891f0";
export var lineThrough = "style-module--lineThrough--1da93";
export var oekoIcon = "style-module--oekoIcon--a3efc";
export var reduction = "style-module--reduction--9d798";
export var reductionValue = "style-module--reductionValue--9f7de";
export var totalAmount = "style-module--totalAmount--6def6";
export var totalAmountValue = "style-module--totalAmountValue--26791";
export var totalPrice = "style-module--totalPrice--e73c4";